// TODO: legacy wrapper used by 13 old JSX components — remove once they are migrated to use downloadCsv from @/utils/file directly
import { downloadCsv } from '@/utils/file'

export default (fields, data, fileName, _title) => {
  if (fields) {
    downloadCsv({ data, fields, filename: fileName })
  } else {
    const url = URL.createObjectURL(data)
    const a = document.createElement('a')
    a.download = fileName
    a.href = url
    a.click()
    window.URL.revokeObjectURL(url)
  }
}
